var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                "before-open": _vm.onHandleBeforeOpen,
                data: _vm.tableData,
                option: _vm.tableOption,
                page: _vm.page,
                "table-loading": _vm.tableLoading,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "search-change": _vm.searchChange,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-update": _vm.handleUpdate,
                "row-save": _vm.handleSave,
                "row-del": _vm.rowDel,
              },
              scopedSlots: _vm._u([
                {
                  key: "productPlanRelationList",
                  fn: function (ref) {
                    var row = ref.row
                    return _vm._l(
                      row.productPlanRelationList,
                      function (item, index) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            "\n\t\t\t\t\t方案名称：" +
                              _vm._s(item.planName) +
                              " 方案Id：" +
                              _vm._s(item.planId) +
                              "\n\t\t\t\t"
                          ),
                        ])
                      }
                    )
                  },
                },
                {
                  key: "productPlanRelationListForm",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm.form.productPlanRelationList &&
                      _vm.form.productPlanRelationList.length > 0
                        ? _c(
                            "div",
                            _vm._l(
                              _vm.form.productPlanRelationList,
                              function (item, index) {
                                return _c(
                                  "el-row",
                                  { key: index },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10 } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入方案id",
                                          },
                                          model: {
                                            value: item.planId,
                                            callback: function ($$v) {
                                              _vm.$set(item, "planId", $$v)
                                            },
                                            expression: "item.planId",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 10 } },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入方案名称",
                                          },
                                          model: {
                                            value: item.planName,
                                            callback: function ($$v) {
                                              _vm.$set(item, "planName", $$v)
                                            },
                                            expression: "item.planName",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 4 } },
                                      [
                                        _c("el-button", {
                                          staticStyle: { "margin-left": "5px" },
                                          attrs: {
                                            circle: "",
                                            icon: "el-icon-plus",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.form.productPlanRelationList
                                                ? _vm.form.productPlanRelationList.push(
                                                    {}
                                                  )
                                                : (_vm.form.productPlanRelationList =
                                                    [{}])
                                            },
                                          },
                                        }),
                                        _c("el-button", {
                                          staticStyle: { "margin-left": "5px" },
                                          attrs: {
                                            circle: "",
                                            icon: "el-icon-minus",
                                            type: "danger",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.form.productPlanRelationList.splice(
                                                index,
                                                1
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c("el-button", {
                                attrs: {
                                  circle: "",
                                  icon: "el-icon-plus",
                                  type: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.form.productPlanRelationList
                                      ? _vm.form.productPlanRelationList.push(
                                          {}
                                        )
                                      : (_vm.form.productPlanRelationList = [
                                          {},
                                        ])
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-edit", type: "primary" },
                      on: { click: _vm.openImport },
                    },
                    [_vm._v("批量切换产品id")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.importModal,
                "append-to-body": "",
                title: "批量切换产品id",
                width: "35%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.importModal = $event
                },
              },
            },
            [
              _c("div", { staticClass: "import-main" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "flex-direction": "column",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "el-upload",
                      {
                        attrs: {
                          "before-upload": _vm.beforeUpload,
                          "file-list": _vm.importFileList,
                          limit: 1,
                          "on-remove": _vm.handleRemove,
                          accept: ".xlsx",
                          action: "",
                          drag: "",
                          multiple: "",
                        },
                      },
                      [
                        _c("i", { staticClass: "el-icon-upload" }),
                        _c("div", { staticClass: "upload-import-text-main" }, [
                          _c("span", [
                            _vm._v("点击上传或拖拽文件到这里进行上传"),
                          ]),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.downImportExcel } }, [
                    _vm._v("下载模板"),
                  ]),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.importModal = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.importFileList.length == 0,
                        type: "primary",
                      },
                      on: { click: _vm.confirmBatchExport },
                    },
                    [_vm._v("导入")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }